module.exports = __webpack_public_path__ + "static/img/huawei-appgallery-badge-ca.91b2285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huawei-appgallery-badge-ca.png
// module id = LSxh
// module chunks = 1